export class TmProductForPRP {
    ProductType: string;
    BadgeImagePath: string;
    Installments: number;
    IsPriceRange: string;
    ItemNo: string;
    Name: string;
    Overview: string;
    PricePromoLabel: string;
    AppliedOfferMessage: string;
    ProductReviewCount: number;
    ProductReviewRating: number;
    VideosCount: number;
    WasPriceRange: string;
    LinkWithoutDomain: string;
    EasyPaymentPrice: string;
    ImageUrl: string;
    ShowBadgeImage: boolean;
    DefaultEdp: number;
    Edps: TmEdpForPRP[];
    OnAirInfo: TmOnAirInfo;
    IsLive: boolean;
    ProductTypes: string[];
    Brand: string;
}

export class TmOnAirInfo {
    OnAirStart: Date;
    DurationInSecond: number;
}

export type TmSellerType = 'TSC' | 'TSCPartner' | 'Marketplace';

export enum TmSellerTypeEnum {
    TSC = '0',
    TSCPartner = '1',
    Marketplace = '2',
}

export class TmProduct {
    // AlternateImages: TmImage[];
    AlternateImageUrls: string[];
    BadgeImagePath: string;
    Brand: string;
    BrandLink: TmLink;
    CustomFields: TmProductCustomField[];
    DefaultDimensionId: number;
    DefaultEdp: number;
    EasyPaymentPrice: string;
    Edps: TmEdp[];
    EnabledAddToCart: boolean;
    ImageUrl: string;
    Installments: number;
    IsLive: boolean;
    IsPriceRange: string;
    IsShowstopper: boolean;
    IsSoldOut: boolean;
    IsWebOnly: boolean;
    IsRestricted: boolean;
    IsDonation: boolean;
    RestrictedProvinces: string[];
    ItemNo: string;
    Name: string;
    OnAirInfo: TmOnAirInfo;
    Overview: string;
    PriceIsLabel: string;
    PricePromoLabel: string;
    PriceWasLabel: string;
    ProductLink: TmLink;
    ProductMessages: TmProductMessages;
    ProductReviewCount: number;
    ProductReviewRating: number;
    ProductType: string;
    ProductTypeLink: TmLink;
    ProductTypes: string[];
    ProductTypePath: TmFacet[];
    QuickViewLink: TmLink;
    RelatedItemNos: string[];
    AutoDeliveryItemNos: string[];
    SavePriceLabel: string;
    SellerType: TmSellerType;
    SellerId: string;
    SellerName: string;
    SellerPageLink: string;
    ShowBadgeImage: boolean;
    ShowPriceIs: boolean;
    ShowPricePromo: boolean;
    ShowPriceWas: boolean;
    Sizes: TmDimension[];
    Styles: TmDimension[];
    DeliveryOptions: TmDeliveryOption[];
    AvailableSwatches: string[];
    Videos: TmVideo[];
    WasPriceRange: string;
}

export class TmEdp {
    EdpNo: number;
    UpcNo: number;
    AppliedPrice: string;
    AppliedShipping: string;
    EasyPaymentPrice: string;
    // Images: TmImage[];
    ImageUrl: string;
    Inventory: number;
    ItemNo: string;
    PriceWasLabel: string;
    SavePrice: string;
    Size: string;
    SizeDimensionId: string;
    SkuAvailabilityMessage: string;
    //SkuAvailabilityType: number;
    Style: string;
    StyleDimensionId: string;
    WasPrice: string;
    Quantities: number[];
    IsSoldOut: boolean;
    IsDonation: boolean;
    IsAdvanceOrBackOrder: boolean;
    IsSOEligible: boolean;
}

export class TmImage {
    Height: number;
    ImageURL: string;
    Width: number;
}

export class TmEdpForPRP {
    AppliedPrice: string;
    AppliedShipping: string;
    EasyPaymentPrice: string;
    EdpNo: number;
    ImageUrl: string;
    Inventory: number;
    Size: string;
    SizeDimensionId: string;
    Style: string;
    StyleDimensionId: string;
    Upc: number;
    PriceWasLabel: string;
    SavePrice: string;
    UpcNo: string;
}

export class TmDimension {
    DimensionId: string;
    DisplayName: string;
    Disabled: boolean;
}

export class TmDeliveryOption {
    EdpNo: number;
    DisplayName: string;
}

export class TmVideo {
    Description: string;
    Thumbnail: string;
    Filename: string;
    Format: string;
}

export class TmProductCustomField {
    Sequence: number;
    DisplayName: string;
    MaxLength: number;
    DisplayValue: string;
}

export class TmProductMessages {
    AppliedOfferMessage: string;
}

export class TmTellAFriendEmail {
    constructor(
        public senderName: string,
        public senderEmail: string,
        public recipientName: string,
        public recipientEmail: string,
        public itemName: string,
        public itemImage: string,
        public itemURL: string,
        public customMessage: string,
    ) {}
}
export class TmProductSection {
    Name: string;
    Order: number;
    Contents: TmProductSectionContent;
}

export class TmProductSectionContent {
    ContentOrder: number;
    Content: string;
}

export class TmFacet {
    FacetTypeId: string;
    FacetValueId: string;
    FacetValueNameEn: string;
    FacetValueNameFr: string;
    FacetValueDisplayName: string;
    FacetValueParentId: string;
    FacetValueDisplayOrder: number;
}

export class TmLink {
    ShortLinkText: string;
    LinkText: string;
    LinkWithoutDomain: string;
}

export class AlterModel {
    public Images: OneAlterModel[];
}

export class OneAlterModel {
    public SmallHeight: string;
    public BigHeight: string;
    public SmallWidth: string;
    public BigWidth: string;
    public id: number;
    public SmallImage: string;
    public BigImage: string;
}

export class OneEdpImageModel {
    public SmallImage: string;
    public MidImage: string;
    public BigImage: string;
    public ImageFileName: string;
    public Edp: boolean;
    public StyleId: string;
    public Index: number;

    constructor(edp: boolean, styleId: string) {
        this.StyleId = styleId;
        this.Edp = edp;
    }
}

export class TmProductRecentlyViewed extends TmProduct {
    favoured = false;
}
